import React from 'react';
import { SkeletonGroupProps } from './SkeletonGroup.types';
import { st, classes, vars } from './SkeletonGroup.st.css';
import { SkeletonGroupContext } from './SkeletonGroupAPI';

/** SkeletonGroup */
function SkeletonGroup({
  dataHook,
  className,
  skin = 'light',
  children,
  backgroundColor,
}: SkeletonGroupProps) {
  return (
    <div
      data-hook={dataHook}
      className={st(classes.root, className)}
      style={{
        [vars['color']]: backgroundColor,
      }}
      data-status="loading"
    >
      <SkeletonGroupContext.Provider value={{ skin }}>
        {children}
      </SkeletonGroupContext.Provider>
      <div className={classes.animator} />
    </div>
  );
}

SkeletonGroup.displayName = 'SkeletonGroup';

export { SkeletonGroup };
